import { useContext, useMemo, useState } from "react";
import { useDebounce } from "hooks/lib-ui";
import { CityContext } from "contexts/city-context-provider";
import { filterArrayByString, sortAscLocale } from "helper/array";
import { DropdownAutoCompleteSelect, OptionType } from "../form-control/dropdown-autocomplete";

export const CityListing = () => {
  const [value, setValue] = useState<string>("");
  const searchString = useDebounce(value, 500);
  const { currentCity, handleSelectCity, cityList, isCityListLoading } = useContext(CityContext);
  const listCity = useMemo((): OptionType[] => {
    if (isCityListLoading || !cityList) {
      return [];
    }
    const newList = cityList.map((city) => ({
      value: city.id,
      label: city.name,
    }));
    return sortAscLocale(newList, "label");
  }, [cityList, isCityListLoading]);

  const handleSearch = (value: string) => {
    setValue(value);
  };

  const filteredCity = filterArrayByString(listCity, "label", searchString);

  return (
    <div className="w-52">
      {isCityListLoading ? (
        <CitySkeleton />
      ) : (
        <DropdownAutoCompleteSelect
          value={currentCity?.id}
          options={filteredCity}
          onChangeValue={(value) => handleSelectCity(value)}
          handleSearch={handleSearch}
          searchString={value}
          placeholder="Sélectionner une ville"
          className="w-full shadow-lg"
        />
      )}
    </div>
  );
};

export const CitySkeleton = () => {
  return (
    <div className="rounded-md p-2.5 max-w-sm w-full mx-auto bg-secondary">
      <div className="animate-pulse flex space-x-4">
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-gray-300 rounded-sm" />
        </div>
      </div>
    </div>
  );
};
